import React, { useState } from 'react';
import { ChartColumn, Eye, Info, Save } from 'lucide-react';
import { Dialog, DialogHeader, DialogContent, DialogTitle } from 'src/components/ui/dialog';

interface ClientCreationMenuBarProps {
  hasChanges: boolean;
  showCustomize: boolean;
  setShowCustomize: (show: boolean) => void;
  handleReset: () => void;
  handleSave: () => void;
  handlePreview: () => void;
}

const ClientCreationMenuBar: React.FC<ClientCreationMenuBarProps> = ({
  hasChanges,
  showCustomize,
  setShowCustomize,
  handleSave,
  handleReset,
  handlePreview,
}) => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <div className='flex flex-row items-center text-black bg-gray-201 justify-between sticky top-0 z-99999'>
      <div className='flex flex-row items-center gap-2'>
        <div
          className='flex flex-row items-center gap-2 p-2 border-r border-gray-400 rounded-none hover:bg-gray-400 cursor-pointer relative'
          onClick={() => handleSave()}
        >
          <Save className='size-4' />
          <span className='text-black text-xs'>
            Save
          </span>
          {hasChanges && (
            <div className='absolute top-1 left-1 size-2 bg-red-501 rounded-full' />
          )}
        </div>
        <div
          className={`flex flex-row items-center gap-2 p-2 border-r border-gray-400 rounded-none hover:bg-gray-400 cursor-pointer ${showCustomize ? 'bg-gray-400' : ''}`}
          onClick={() => setShowCustomize(!showCustomize)}
        >
          <ChartColumn className='size-4' />
          <span className='text-black text-xs'>
            Customize
          </span>
        </div>
        <div
          className='flex flex-row items-center gap-2 p-2 border-r border-gray-400 rounded-none hover:bg-gray-400 cursor-pointer'
          onClick={() => handlePreview()}
        >
          <Eye className='size-4' />
          <span className='text-black text-xs'>
            Preview
          </span>
        </div>
        <div
          className='flex flex-row items-center gap-2 p-2 border-r border-gray-400 rounded-none hover:bg-gray-400 cursor-pointer'
          onClick={() => setShowHelp(!showHelp)}
        >
          <Info className='size-4' />
          <span className='text-black text-xs'>
            Help
          </span>
        </div>
      </div>
      <div className='text-red-501 text-xs font-bold mr-2'>
        {hasChanges ? 'Changes have not been saved.' : ''}
      </div>
      {/* <div
        className='flex flex-row items-center cursor-pointer'
        onClick={() => setShowHelp(!showHelp)}
      >
        <Info className='size-4 mr-1' />
        <span className='text-gray-500 text-xs'>
          Help
        </span>
      </div> */}
      <Dialog
        open={showHelp}
        onOpenChange={setShowHelp}
      >
        <DialogContent className='sm:max-w-[900px] bg-white max-h-[95vh] overflow-y-auto'>
          <DialogHeader>
            <DialogTitle>
              <div className='flex flex-row items-center gap-2 text-h2'>
                <Info className='size-4' />
                Help
              </div>
            </DialogTitle>
          </DialogHeader>
          <div className='space-y-4 py-4'>
            <div className='flex flex-row items-center gap-2 font-bold'>
              Assigning Access
            </div>
            <div className='flex flex-row items-center gap-2'>
              To define access, click a company, account or campaign.  Toggling a company or account will automatically toggle all of its accounts and/or campaigns.
            </div>
            <div className='flex flex-row items-center gap-2'>
              Auto+ Accounts and Auto+ Campaigns will automatically assign all new accounts and campaigns to the client if they fall under any of the selected companies.  This feature only is available if you assign a company.
            </div>
            {/* <div className='flex flex-row items-center gap-2'>
              Clicking `Reset` will clear all access and return the client to the default state.
            </div> */}
            <div className='flex flex-row items-center gap-2 font-bold'>
              Customizing the Client
            </div>
            <div className='flex flex-row items-center gap-2'>
              Clicking `Customize` will open the customize panel.  Here you can change what the client sees based on their chosen account.  You can also set a default view that applies to all accounts that have not been set.
            </div>
            <div className='flex flex-row items-center gap-2'>
              Clicking `Save` will save the changes to the client.
            </div>

          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ClientCreationMenuBar;
